// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface INotificationPropertiesInfoDto
 */
export interface INotificationPropertiesInfoDto {
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_verify_email?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_welcome?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_welcome?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_reset_password?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_reset_password?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_card_status_change?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_claim_activity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_claim_activity_no_action?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_payment_method_change?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_replenishment_invoice_ready_pull?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_replenishment_invoice_ready_push?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_contribution_invoice_ready_pull?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_contribution_invoice_ready_push?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_card_activation_reminder?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_trigger?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_ach_rejected?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_account_closure?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_prefund_pull?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_orphan?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_file_processed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_individual_contribution?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_statement_generated?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_cip_failed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_individual_contribution_reminder?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_outstanding_check_reminder?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_check_void?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_automatic_investments?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_failed_reimbursement?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_check_expired?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_individual_contribution_failed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_mfa?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_email_verification?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_forgot_user_name?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_forgot_user_name?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_complete_setup?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_election_needed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_balance_reminder_initial?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_balance_reminder?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_contact_info_updated?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_scheduled_contribution?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_claim_offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_new_bank_account_added?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_person_accounts_linked?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_tax_form_generated?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_prefund_push?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_file_duplicate_found?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    internal_feedback?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    beneficiary_update?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_renewal_initial_reminder?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_renewal_request?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_cip_failed_closed_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_renewal_reminder?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    admin_scheduled_report_generated?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    participant_push_provisioning?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    eoy_shortage_pull?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    eoy_shortage_push?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    return_unused_funds?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    contribution_return_push_pull?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    excess_contribution_processed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    combine_hsa_employee_email?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    authorized_user?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    baf_collect_pull?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    baf_collect_push?: number | null;
    /**
     * 
     * @type {number}
     * @memberof INotificationPropertiesInfoDto
     */
    baf_return_pull_push?: number | null;
}

/**
 * Check if a given object implements the INotificationPropertiesInfoDto interface.
 */
export function instanceOfINotificationPropertiesInfoDto(value: object): value is INotificationPropertiesInfoDto {
    return true;
}

export function INotificationPropertiesInfoDtoFromJSON(json: any): INotificationPropertiesInfoDto {
    return INotificationPropertiesInfoDtoFromJSONTyped(json, false);
}

export function INotificationPropertiesInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): INotificationPropertiesInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'participant_verify_email': json['participant_verify_email'] == null ? undefined : json['participant_verify_email'],
        'admin_welcome': json['admin_welcome'] == null ? undefined : json['admin_welcome'],
        'participant_welcome': json['participant_welcome'] == null ? undefined : json['participant_welcome'],
        'participant_reset_password': json['participant_reset_password'] == null ? undefined : json['participant_reset_password'],
        'admin_reset_password': json['admin_reset_password'] == null ? undefined : json['admin_reset_password'],
        'participant_card_status_change': json['participant_card_status_change'] == null ? undefined : json['participant_card_status_change'],
        'participant_claim_activity': json['participant_claim_activity'] == null ? undefined : json['participant_claim_activity'],
        'participant_claim_activity_no_action': json['participant_claim_activity_no_action'] == null ? undefined : json['participant_claim_activity_no_action'],
        'participant_payment_method_change': json['participant_payment_method_change'] == null ? undefined : json['participant_payment_method_change'],
        'admin_replenishment_invoice_ready_pull': json['admin_replenishment_invoice_ready_pull'] == null ? undefined : json['admin_replenishment_invoice_ready_pull'],
        'admin_replenishment_invoice_ready_push': json['admin_replenishment_invoice_ready_push'] == null ? undefined : json['admin_replenishment_invoice_ready_push'],
        'admin_contribution_invoice_ready_pull': json['admin_contribution_invoice_ready_pull'] == null ? undefined : json['admin_contribution_invoice_ready_pull'],
        'admin_contribution_invoice_ready_push': json['admin_contribution_invoice_ready_push'] == null ? undefined : json['admin_contribution_invoice_ready_push'],
        'participant_card_activation_reminder': json['participant_card_activation_reminder'] == null ? undefined : json['participant_card_activation_reminder'],
        'participant_trigger': json['participant_trigger'] == null ? undefined : json['participant_trigger'],
        'admin_ach_rejected': json['admin_ach_rejected'] == null ? undefined : json['admin_ach_rejected'],
        'participant_account_closure': json['participant_account_closure'] == null ? undefined : json['participant_account_closure'],
        'admin_prefund_pull': json['admin_prefund_pull'] == null ? undefined : json['admin_prefund_pull'],
        'participant_orphan': json['participant_orphan'] == null ? undefined : json['participant_orphan'],
        'admin_file_processed': json['admin_file_processed'] == null ? undefined : json['admin_file_processed'],
        'participant_individual_contribution': json['participant_individual_contribution'] == null ? undefined : json['participant_individual_contribution'],
        'participant_statement_generated': json['participant_statement_generated'] == null ? undefined : json['participant_statement_generated'],
        'participant_cip_failed': json['participant_cip_failed'] == null ? undefined : json['participant_cip_failed'],
        'participant_individual_contribution_reminder': json['participant_individual_contribution_reminder'] == null ? undefined : json['participant_individual_contribution_reminder'],
        'participant_outstanding_check_reminder': json['participant_outstanding_check_reminder'] == null ? undefined : json['participant_outstanding_check_reminder'],
        'participant_check_void': json['participant_check_void'] == null ? undefined : json['participant_check_void'],
        'participant_automatic_investments': json['participant_automatic_investments'] == null ? undefined : json['participant_automatic_investments'],
        'participant_failed_reimbursement': json['participant_failed_reimbursement'] == null ? undefined : json['participant_failed_reimbursement'],
        'participant_check_expired': json['participant_check_expired'] == null ? undefined : json['participant_check_expired'],
        'participant_individual_contribution_failed': json['participant_individual_contribution_failed'] == null ? undefined : json['participant_individual_contribution_failed'],
        'participant_mfa': json['participant_mfa'] == null ? undefined : json['participant_mfa'],
        'participant_email_verification': json['participant_email_verification'] == null ? undefined : json['participant_email_verification'],
        'participant_forgot_user_name': json['participant_forgot_user_name'] == null ? undefined : json['participant_forgot_user_name'],
        'admin_forgot_user_name': json['admin_forgot_user_name'] == null ? undefined : json['admin_forgot_user_name'],
        'admin_complete_setup': json['admin_complete_setup'] == null ? undefined : json['admin_complete_setup'],
        'admin_election_needed': json['admin_election_needed'] == null ? undefined : json['admin_election_needed'],
        'participant_balance_reminder_initial': json['participant_balance_reminder_initial'] == null ? undefined : json['participant_balance_reminder_initial'],
        'participant_balance_reminder': json['participant_balance_reminder'] == null ? undefined : json['participant_balance_reminder'],
        'participant_contact_info_updated': json['participant_contact_info_updated'] == null ? undefined : json['participant_contact_info_updated'],
        'admin_scheduled_contribution': json['admin_scheduled_contribution'] == null ? undefined : json['admin_scheduled_contribution'],
        'participant_claim_offset': json['participant_claim_offset'] == null ? undefined : json['participant_claim_offset'],
        'participant_new_bank_account_added': json['participant_new_bank_account_added'] == null ? undefined : json['participant_new_bank_account_added'],
        'participant_person_accounts_linked': json['participant_person_accounts_linked'] == null ? undefined : json['participant_person_accounts_linked'],
        'participant_tax_form_generated': json['participant_tax_form_generated'] == null ? undefined : json['participant_tax_form_generated'],
        'admin_prefund_push': json['admin_prefund_push'] == null ? undefined : json['admin_prefund_push'],
        'admin_file_duplicate_found': json['admin_file_duplicate_found'] == null ? undefined : json['admin_file_duplicate_found'],
        'internal_feedback': json['internal_feedback'] == null ? undefined : json['internal_feedback'],
        'beneficiary_update': json['beneficiary_update'] == null ? undefined : json['beneficiary_update'],
        'admin_renewal_initial_reminder': json['admin_renewal_initial_reminder'] == null ? undefined : json['admin_renewal_initial_reminder'],
        'admin_renewal_request': json['admin_renewal_request'] == null ? undefined : json['admin_renewal_request'],
        'participant_cip_failed_closed_account': json['participant_cip_failed_closed_account'] == null ? undefined : json['participant_cip_failed_closed_account'],
        'admin_renewal_reminder': json['admin_renewal_reminder'] == null ? undefined : json['admin_renewal_reminder'],
        'admin_scheduled_report_generated': json['admin_scheduled_report_generated'] == null ? undefined : json['admin_scheduled_report_generated'],
        'participant_push_provisioning': json['participant_push_provisioning'] == null ? undefined : json['participant_push_provisioning'],
        'eoy_shortage_pull': json['eoy_shortage_pull'] == null ? undefined : json['eoy_shortage_pull'],
        'eoy_shortage_push': json['eoy_shortage_push'] == null ? undefined : json['eoy_shortage_push'],
        'return_unused_funds': json['return_unused_funds'] == null ? undefined : json['return_unused_funds'],
        'contribution_return_push_pull': json['contribution_return_push_pull'] == null ? undefined : json['contribution_return_push_pull'],
        'excess_contribution_processed': json['excess_contribution_processed'] == null ? undefined : json['excess_contribution_processed'],
        'combine_hsa_employee_email': json['combine_hsa_employee_email'] == null ? undefined : json['combine_hsa_employee_email'],
        'authorized_user': json['authorized_user'] == null ? undefined : json['authorized_user'],
        'baf_collect_pull': json['baf_collect_pull'] == null ? undefined : json['baf_collect_pull'],
        'baf_collect_push': json['baf_collect_push'] == null ? undefined : json['baf_collect_push'],
        'baf_return_pull_push': json['baf_return_pull_push'] == null ? undefined : json['baf_return_pull_push'],
    };
}

export function INotificationPropertiesInfoDtoToJSON(json: any): INotificationPropertiesInfoDto {
    return INotificationPropertiesInfoDtoToJSONTyped(json, false);
}

export function INotificationPropertiesInfoDtoToJSONTyped(value?: INotificationPropertiesInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'participant_verify_email': value['participant_verify_email'],
        'admin_welcome': value['admin_welcome'],
        'participant_welcome': value['participant_welcome'],
        'participant_reset_password': value['participant_reset_password'],
        'admin_reset_password': value['admin_reset_password'],
        'participant_card_status_change': value['participant_card_status_change'],
        'participant_claim_activity': value['participant_claim_activity'],
        'participant_claim_activity_no_action': value['participant_claim_activity_no_action'],
        'participant_payment_method_change': value['participant_payment_method_change'],
        'admin_replenishment_invoice_ready_pull': value['admin_replenishment_invoice_ready_pull'],
        'admin_replenishment_invoice_ready_push': value['admin_replenishment_invoice_ready_push'],
        'admin_contribution_invoice_ready_pull': value['admin_contribution_invoice_ready_pull'],
        'admin_contribution_invoice_ready_push': value['admin_contribution_invoice_ready_push'],
        'participant_card_activation_reminder': value['participant_card_activation_reminder'],
        'participant_trigger': value['participant_trigger'],
        'admin_ach_rejected': value['admin_ach_rejected'],
        'participant_account_closure': value['participant_account_closure'],
        'admin_prefund_pull': value['admin_prefund_pull'],
        'participant_orphan': value['participant_orphan'],
        'admin_file_processed': value['admin_file_processed'],
        'participant_individual_contribution': value['participant_individual_contribution'],
        'participant_statement_generated': value['participant_statement_generated'],
        'participant_cip_failed': value['participant_cip_failed'],
        'participant_individual_contribution_reminder': value['participant_individual_contribution_reminder'],
        'participant_outstanding_check_reminder': value['participant_outstanding_check_reminder'],
        'participant_check_void': value['participant_check_void'],
        'participant_automatic_investments': value['participant_automatic_investments'],
        'participant_failed_reimbursement': value['participant_failed_reimbursement'],
        'participant_check_expired': value['participant_check_expired'],
        'participant_individual_contribution_failed': value['participant_individual_contribution_failed'],
        'participant_mfa': value['participant_mfa'],
        'participant_email_verification': value['participant_email_verification'],
        'participant_forgot_user_name': value['participant_forgot_user_name'],
        'admin_forgot_user_name': value['admin_forgot_user_name'],
        'admin_complete_setup': value['admin_complete_setup'],
        'admin_election_needed': value['admin_election_needed'],
        'participant_balance_reminder_initial': value['participant_balance_reminder_initial'],
        'participant_balance_reminder': value['participant_balance_reminder'],
        'participant_contact_info_updated': value['participant_contact_info_updated'],
        'admin_scheduled_contribution': value['admin_scheduled_contribution'],
        'participant_claim_offset': value['participant_claim_offset'],
        'participant_new_bank_account_added': value['participant_new_bank_account_added'],
        'participant_person_accounts_linked': value['participant_person_accounts_linked'],
        'participant_tax_form_generated': value['participant_tax_form_generated'],
        'admin_prefund_push': value['admin_prefund_push'],
        'admin_file_duplicate_found': value['admin_file_duplicate_found'],
        'internal_feedback': value['internal_feedback'],
        'beneficiary_update': value['beneficiary_update'],
        'admin_renewal_initial_reminder': value['admin_renewal_initial_reminder'],
        'admin_renewal_request': value['admin_renewal_request'],
        'participant_cip_failed_closed_account': value['participant_cip_failed_closed_account'],
        'admin_renewal_reminder': value['admin_renewal_reminder'],
        'admin_scheduled_report_generated': value['admin_scheduled_report_generated'],
        'participant_push_provisioning': value['participant_push_provisioning'],
        'eoy_shortage_pull': value['eoy_shortage_pull'],
        'eoy_shortage_push': value['eoy_shortage_push'],
        'return_unused_funds': value['return_unused_funds'],
        'contribution_return_push_pull': value['contribution_return_push_pull'],
        'excess_contribution_processed': value['excess_contribution_processed'],
        'combine_hsa_employee_email': value['combine_hsa_employee_email'],
        'authorized_user': value['authorized_user'],
        'baf_collect_pull': value['baf_collect_pull'],
        'baf_collect_push': value['baf_collect_push'],
        'baf_return_pull_push': value['baf_return_pull_push'],
    };
}

